import { Spinner, SpinnerSize } from '@fluentui/react'
import React from 'react'

const customSpinnerStyle = {
  padding: "auto",
  height: "100vh",
  width: "100vw",
  zIndex: "999",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "black",
  opacity: "0.5",
  position: "fixed",
  top: "0",
  left: "0"
}

const spinnerStyle = {
  circle: {
    height: "50px",
    width: "50px",
    borderWidth: "5px",
  }
}

const CustomSpinner = (props) => {
  return (
    <>
        <div
            style={props.parentDivStyle == null || props.parentDivStyle == undefined? customSpinnerStyle:props.parentDivStyle }
          >
            <Spinner size={SpinnerSize.large} styles={spinnerStyle}/>
            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
              {props.loadingState}
            </p>
          </div>
    </>
  )
}

export default CustomSpinner